import React, { useContext, useEffect, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import useEnv from "../../../../hooks/env";
import LaboratoriesApi from "../../../../api/services/LaboratoriesApi";
import ErrorSnackbarContext from "../../../../contexts/ErrorSnackbarContext";

interface INotificationFormProps {
  laboratoryId: number;
  submittedRequestNotificationActive: boolean;
}
const NotificationForm = (props: INotificationFormProps) => {
  const { laboratoryId, submittedRequestNotificationActive } = props;
  const { api } = useEnv();
  const labsApi = new LaboratoriesApi(api);

  const { handleHttpError, showSnackbar } = useContext(ErrorSnackbarContext);
  const [checked, setChecked] = useState<boolean>(true);

  useEffect(() => {
    setChecked(submittedRequestNotificationActive);
  }, [laboratoryId, submittedRequestNotificationActive]);

  const handleApiCallback = () => {
    const data = {
      submittedRequestNotificationActive: !checked as boolean,
    };

    const message: string = !checked ? "activated" : "deactivated";

    labsApi
      .editNotificationConfiguration(laboratoryId, data)
      .then(() => {
        showSnackbar(`Notifications about new requests are now ${message}`, "success");
      })
      .catch(handleHttpError);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    handleApiCallback();
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={<Checkbox defaultChecked checked={checked} onChange={handleChange} />}
        label={<Typography variant="body2">Send notifications about new requests</Typography>}
      />
    </FormGroup>
  );
};

export default NotificationForm;
